import React, {useEffect, useRef, useState} from "react";
import {IntlShape} from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import {getFeatureGroupName} from "../../../misc/helpers";

type FeatureGroupItem = {
  partId: string,
  featureGroup: any,
};

type Props = {
  featureArea: string,
  featureGroupItems: FeatureGroupItem[],
  selectedPartIds: string[],
  onToggle: (featureArea: string, partId: string) => void,
  intl: IntlShape,
  fabricatorData: any,
};

export default function UiPopupAIContentFeaturesAreaDropdown({
  featureArea,
  featureGroupItems,
  selectedPartIds,
  onToggle,
  intl,
  fabricatorData,
}: Props) {

  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const selectedCount = selectedPartIds.length;

  return (
    <div ref={containerRef} className="text-left relative w-full">
      <div
        className="w-full u-h-2 u-p-025 u-rounded-025 flex--between border border-[#e2e2e2] border-solid
        color-primary flex flex--center gap-05 cursor-pointer noselect"
        onClick={() => setIsOpen(open => !open)}
      >
        <span className="font--14">{selectedCount} {selectedCount === 1 ? "group" : "groups"}</span>
        <span style={{
          display: "inline-block",
          transform: isOpen ? "rotate(180deg)" : "none",
          transition: "transform 0.15s ease",
          fontSize: 21,
          lineHeight: 0,
        }}>▾</span>
      </div>
      {isOpen ? (
        <div
          className="scrollable absolute z-10 h-[200px] top-full left-0 min-w-[220px] bg-white u-rounded-025 py-1 px-2"
          style={{
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          }}
        >
          <ul className="fix-ul">
            {featureGroupItems.map(({partId, featureGroup}) => (
              <li key={partId} className="ass-list__item">
                <FormControlLabel
                  className="ll-text bold color-primary text-left leading-1 font--14 uppercase"
                  label={getFeatureGroupName(featureGroup, intl, fabricatorData)}
                  control={
                    <Checkbox
                      size="small"
                      value={partId}
                      checked={selectedPartIds.includes(partId)}
                      onChange={() => onToggle(featureArea, partId)}
                    />
                  }
                />
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
